import type { IActionsProps, IDropdownItem } from 'shared/ui'
import { TreeRootInboxes, type IBaseInbox, type InboxType } from 'entities/Inbox/model/types'
import { TYPES_INBOX } from 'entities/Inbox/store/types'

export class BaseInbox<T extends IBaseInbox = IBaseInbox> {
  id = 0
  is_favorite = false
  name = ''
  type: InboxType

  constructor(response: T) {
    this.id = response.id
    this.type = 'inbox'
    this.is_favorite = response.is_favorite
  }
  actionsProps?: IActionsProps | null = null

  setActionsProps?: ((actionProps: IActionsProps) => void) | null = (
    actionProps: IActionsProps
  ) => {
    this.actionsProps = actionProps
  }

  get inboxType() {
    return TYPES_INBOX.UNIFIED
  }

  get isGroupInbox() {
    return this.inboxType === TYPES_INBOX.GROUP
  }

  get isUnifiedInbox() {
    return this.inboxType === TYPES_INBOX.UNIFIED
  }

  get isSmartInbox() {
    return this.inboxType === TYPES_INBOX.SMART
  }

  get isSharedInbox() {
    return this.inboxType === TYPES_INBOX.SHARED
  }

  get isSmartViewInbox() {
    return this.inboxType === TYPES_INBOX.UNIFIED
  }

  get isFavoriteType() {
    return Boolean(this.is_favorite)
  }

  get isSimpleType() {
    return Boolean(!this.isSmartInbox)
  }

  get dropdownData(): IDropdownItem {
    return {
      id: this.id,
      label: this.name,
      iconL: 'folder',
    }
  }

  get bodyUpdateTeamsFavorite() {
    return {
      favorite: this.is_favorite ? 0 : 1,
      inbox_id: this.id,
      inbox_type: this.type,
    }
  }

  get bodyCreateTeamsGroupsByIdAddTeams() {
    return {
      team_ids: [this.id],
    }
  }

  initRootTree() {
    if (this.isFavoriteType) return TreeRootInboxes.FAVORITE
    if (this.isSmartViewInbox) return TreeRootInboxes.SMART_VIEW

    return TreeRootInboxes.SIMPLE
  }
}
